import { ref } from 'vue';
import { defineStore } from 'pinia';

interface AssistantChatData {
    assistantId: string;
    threadId: string;
    isMainAssistant: boolean;
}

export const useAssistantChatStore = defineStore('assistantChat', () =>
{
    const assistantChatData = ref<AssistantChatData>({
        assistantId: '',
        threadId: '',
        isMainAssistant: false
    });

    return { assistantChatData };
});
